import React from 'react';
import BUTTON_CONFIG from '../../constants/button.constants';
import { DATE_TIME, DURATION, KPHC_CSN_ID, MIN, START_TIME } from '../../constants/report.constant';
import { TOTAL_CLASS_PARTICIPANTS, TOTAL_POLL_PARTICIPANTS, POLL_REPORT_DOWNLOAD_BTN_CLASS } from '../../constants/polls.constant';
import DownloadPollReportButton from '../PollReport/DownloadPollReportButton';
import { DOWNLOAD_POLL_REPORT_PAGE_PATH } from '../../constants/route.constants';

const PollsGroupDetailCard = groupClassDetailProp => {
  const {
    zoomMeetingUuid,
    scheduleDateTime: appointmentSchdDateTime,
    displayActualStartTime,
    appointmentCSNId,
    appointmentSchdDuration,
    totalPollParticipants,
    totalClassParticipants
  } = groupClassDetailProp;

  const downloadButtonProps = {
    btnClass: POLL_REPORT_DOWNLOAD_BTN_CLASS,
    btnLabel: BUTTON_CONFIG.DOWNLOAD_BUTTON.title,
    zoomMeetingUuid,
    pollReportPagePath: DOWNLOAD_POLL_REPORT_PAGE_PATH
  };

  return (
    <div className="vve-group-detail-card">
      <div className="row vve-card-detail">
        <div className="col-md-8 col-sm-8 col-8">
          <span className="vve-group-class-text vve-date-text">
            <span className="vve-text-bold">{DATE_TIME} </span> {appointmentSchdDateTime}
          </span>
          <br />
          <span className="vve-group-class-text">
            <span className="vve-text-bold">{START_TIME} </span> {displayActualStartTime}
          </span>
          <br />
          <span className="vve-group-class-text">
            <span className="vve-text-bold">{KPHC_CSN_ID} </span> {appointmentCSNId}
          </span>
          <br />
          <span className="vve-group-class-text">
            <span className="vve-text-bold">{TOTAL_CLASS_PARTICIPANTS} </span> {totalClassParticipants}
          </span>
          <br />
          <span className="vve-group-class-text">
            <span className="vve-text-bold">{TOTAL_POLL_PARTICIPANTS} </span> {totalPollParticipants}
          </span>
          <br />
          <span className="vve-group-class-text">
            <span className="vve-text-bold">{DURATION} </span> {appointmentSchdDuration} {MIN}
          </span>
        </div>
        <div className="col-md-4 col-sm-4 col-4 vve-download-btn-div">
          <DownloadPollReportButton {...downloadButtonProps} />
        </div>
      </div>
    </div>
  );
};

export default PollsGroupDetailCard;
